import { PageHeader, Section, Overline } from "@/components/Section";
import WaitlistForm from "@/components/WaitlistForm";
import WalkthroughForm from "@/components/WalkthroughForm";
import { Mail, MapPin, Clock } from "lucide-react";

export default function Contact() {
  return (
    <>
      <PageHeader
        overline="Contact"
        title="Two ways in. One human inbox."
        lede="Join the waitlist if you'd like the methodology drops and phase releases. Book a walkthrough if you want to see what's working today and ask hard questions."
        testid="contact-page-header"
      />

      <Section testid="contact-forms">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <Overline className="mb-6">Walkthrough request</Overline>
            <h2 className="text-3xl md:text-4xl font-black tracking-tighter text-[#0A1224] leading-tight mb-3">
              Book a walkthrough.
            </h2>
            <p className="text-slate-600 leading-relaxed mb-10">
              Tell us where you sit on the continuum of care and what you'd most want answered.
              We respond within two business days. Walkthroughs run 30–45 minutes with the
              founder or a lead analyst — never with someone reading a deck for the first time.
            </p>
            <WalkthroughForm testid="contact-walkthrough-form" />
          </div>

          <aside className="lg:col-span-5">
            <div className="bg-[#F8F9FA] p-8 border-t-2 border-[#FF8A00] sticky top-24">
              <Overline className="mb-4">Join the waitlist</Overline>
              <h3 className="text-2xl font-black tracking-tighter text-[#0A1224] mb-3">
                Not ready to talk yet?
              </h3>
              <p className="text-slate-600 mb-6 leading-relaxed">
                Get phase releases, methodology drops, and pricing decisions as they're made.
              </p>
              <WaitlistForm compact testid="contact-waitlist-form" />
            </div>

            <div className="mt-8 space-y-6">
              <div className="flex items-start gap-4">
                <Mail className="text-[#FF8A00] flex-shrink-0 mt-1" size={20} />
                <div>
                  <Overline>Email</Overline>
                  <a
                    href="mailto:hello@getcontinuum.com"
                    data-testid="contact-email-link"
                    className="text-[#0A1224] font-bold mt-1 inline-block hover:text-[#FF8A00]"
                  >
                    hello@getcontinuum.com
                  </a>
                  <p className="text-slate-500 text-sm mt-1">Monitored inbox · two-business-day reply</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Clock className="text-[#FF8A00] flex-shrink-0 mt-1" size={20} />
                <div>
                  <Overline>Hours</Overline>
                  <p className="text-[#0A1224] font-medium mt-1">Mon–Fri · 09:00–17:00 MT</p>
                  <p className="text-slate-500 text-sm">We don't run a 24/7 sales motion.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="text-[#FF8A00] flex-shrink-0 mt-1" size={20} />
                <div>
                  <Overline>Based in</Overline>
                  <p className="text-[#0A1224] font-medium mt-1">Alberta, Canada</p>
                  <p className="text-slate-500 text-sm">Data hosted in Canadian regions only.</p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </Section>
    </>
  );
}
